export default __webpack_public_path__ + "static/media/John.2ca40608.gif";